import Highcharts, { color } from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

export const renderChart = (data) => {
    const { rv: crt, sats } = data;
    const xAxis = Object.keys(crt).map(x => new Date(x).toISOString().split('T')[0]);
    const chart = {
        chart: {
            zoomType: 'xy',
            backgroundColor: '#1D1D1D'
        },
        title: {
            text: '',
            align: 'left'
        },
        legend: {
            // layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            symbolRadius: 0,
            itemStyle: {
                "color": 'white',
                "font-family": "Inter",
                "font-size": "12px"
            },
            itemHoverStyle: {
                "color": 'grey',
            },
            labelFormatter: function () {
                if (this.name === "Total Payouts (sats)") {
                    return ("Total Payouts")
                }
                return "Average Hashrate";
            }
            // itemMarginTop: 10,
            // itemMarginBottom: 10
        },
        xAxis: [{
            categories: xAxis,
            crosshair: false,
            gridLineWidth: 0,
            lineWidth: 0,
            labels: {
                format: '{value}',
                style: {
                    color: 'white'
                }
            },
        }],
        yAxis: [{ // Primary yAxis
            labels: {
                format: '{value}',
                style: {
                    color: '#6F767E'
                }
            },
            title: {
                text: '',
                style: {
                    color: '#6F767E'
                }
            },
            lineWidth: 0,
            gridLineWidth: 0,
        },
        { // Secondary yAxis
            title: {
                text: '{value}',
                style: {
                    color: 'transparent',
                    display: 'none'
                }
            },
            labels: {
                format: '{value}',
                style: {
                    color: 'transparent',
                    display: 'none'
                }
            },
            lineWidth: 0,
            gridLineWidth: 0,
            opposite: true
        }
        ],
        tooltip: {
            shared: true,
            headerFormat: null,
            backgroundColor: "#3452F41A",
            style: {
                color: 'white'
            }
        },
        series: [{
            name: 'Total Payouts (sats)',
            type: 'column',
            yAxis: 1,
            maxPointWidth: 50,
            data: Object.values(sats),
            tooltip: {
                valueSuffix: ''
            },
            color: '#706DFF',
            borderColor: null,
            shadow: {
                color: 'white',
                width: 5,
                offsetX: 0,
                offsetY: 0
            },
        }, {
            name: 'Average Hashrate (TH/s)',
            type: 'areaspline',
            data: Object.values(crt),
            tooltip: {
                valueSuffix: ''
            },
            color: '#3553F4',
            fillColor: {
                linearGradient: [0, 0, 0, 300],
                stops: [
                    [0, '#3553F4'],
                    [1, Highcharts.color(Highcharts.getOptions().colors[1]).setOpacity(0).get('rgba')]
                ]
            }
        }],
    }
    return chart;
}